// File: frontend/src/pages/Feedback.tsx
import React from 'react';
import { Typography, Paper, Link, Box, Card, CardContent, Divider } from '@mui/material';
import EmailIcon from '@mui/icons-material/Email';
import GitHubIcon from '@mui/icons-material/GitHub';
import LanguageIcon from '@mui/icons-material/Language';
import XIcon from '@mui/icons-material/X';
import { cyber } from '../theme';

const Feedback = () => {
    return (
        <Box sx={{ maxWidth: '1200px', mx: 'auto' }}>
            <Paper sx={{ p: 4, mb: 3, border: `1px solid ${cyber.border}` }}>
                <Typography variant="h4" component="h1" gutterBottom sx={{ fontWeight: 700 }}>
                    Feedback & Contact
                </Typography>
                <Typography variant="body1" paragraph color="text.secondary">
                    We value your feedback! Whether you have suggestions, found a bug, or want to contribute to the project,
                    we'd love to hear from you. Get in touch through any of the channels below.
                </Typography>

                <Divider sx={{ my: 3 }} />

                <Typography variant="h6" gutterBottom sx={{ fontWeight: 600, mb: 2 }}>
                    Contact Information
                </Typography>

                <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 2, mb: 4 }}>
                    {/* Email */}
                    <Card sx={{ flex: { xs: '1 1 100%', sm: '1 1 calc(50% - 8px)' }, minWidth: 0 }}>
                        <CardContent>
                            <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                                <EmailIcon sx={{ mr: 1, color: 'primary.main' }} />
                                <Typography variant="subtitle1" sx={{ fontWeight: 600 }}>
                                    Email
                                </Typography>
                            </Box>
                            <Link
                                href="mailto:info@ti-mindmap-hub.com"
                                target="_blank"
                                rel="noopener noreferrer"
                                sx={{ wordBreak: 'break-all' }}
                            >
                                info@ti-mindmap-hub.com
                            </Link>
                        </CardContent>
                    </Card>

                    {/* Twitter/X */}
                    <Card sx={{ flex: { xs: '1 1 100%', sm: '1 1 calc(50% - 8px)' }, minWidth: 0 }}>
                        <CardContent>
                            <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                                <XIcon sx={{ mr: 1, color: cyber.accent.cyan }} />
                                <Typography variant="subtitle1" sx={{ fontWeight: 600 }}>
                                    Twitter/X
                                </Typography>
                            </Box>
                            <Link
                                href="https://twitter.com/ti_mindmap_hub"
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                @ti_mindmap_hub
                            </Link>
                        </CardContent>
                    </Card>

                    {/* Platform */}
                    <Card sx={{ flex: { xs: '1 1 100%', sm: '1 1 calc(50% - 8px)' }, minWidth: 0 }}>
                        <CardContent>
                            <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                                <LanguageIcon sx={{ mr: 1, color: cyber.accent.green }} />
                                <Typography variant="subtitle1" sx={{ fontWeight: 600 }}>
                                    Platform
                                </Typography>
                            </Box>
                            <Link
                                href="https://ti-mindmap-hub.com"
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                ti-mindmap-hub.com
                            </Link>
                        </CardContent>
                    </Card>

                    {/* GitHub */}
                    <Card sx={{ flex: { xs: '1 1 100%', sm: '1 1 calc(50% - 8px)' }, minWidth: 0 }}>
                        <CardContent>
                            <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                                <GitHubIcon sx={{ mr: 1, color: cyber.accent.coral }} />
                                <Typography variant="subtitle1" sx={{ fontWeight: 600 }}>
                                    GitHub Repository
                                </Typography>
                            </Box>
                            <Link
                                href="https://github.com/TI-Mindmap-HUB-Org/ti-mindmap-hub-research"
                                target="_blank"
                                rel="noopener noreferrer"
                                sx={{ wordBreak: 'break-all' }}
                            >
                                TI-Mindmap-HUB-Org/ti-mindmap-hub-research
                            </Link>
                        </CardContent>
                    </Card>
                </Box>

                <Divider sx={{ my: 3 }} />

                <Typography variant="h6" gutterBottom sx={{ fontWeight: 600, mb: 2 }}>
                    Report Issues & Contribute
                </Typography>

                <Typography variant="body1" paragraph>
                    For bug reports, feature requests, or technical issues, please open an issue on our GitHub repository.
                    We welcome contributions from the community!
                </Typography>

                <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                    <Box>
                        <Link
                            href="https://github.com/TI-Mindmap-HUB-Org/ti-mindmap-hub-research/issues"
                            target="_blank"
                            rel="noopener noreferrer"
                            sx={{ fontWeight: 500 }}
                        >
                            Open an Issue →
                        </Link>
                    </Box>
                    <Box>
                        <Link
                            href="https://github.com/TI-Mindmap-HUB-Org/ti-mindmap-hub-research/discussions"
                            target="_blank"
                            rel="noopener noreferrer"
                            sx={{ fontWeight: 500 }}
                        >
                            Start a Discussion →
                        </Link>
                    </Box>
                    <Box>
                        <Link
                            href="https://github.com/TI-Mindmap-HUB-Org/ti-mindmap-hub-research"
                            target="_blank"
                            rel="noopener noreferrer"
                            sx={{ fontWeight: 500 }}
                        >
                            View Repository →
                        </Link>
                    </Box>
                </Box>
            </Paper>
        </Box>
    );
};

export default Feedback;